import { Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(8),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('xl')]: {
    marginBottom: theme.spacing(6),
  },
  [theme.breakpoints.down('lg')]: {
    marginBottom: theme.spacing(5),
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
  },
  '& .BLSSearchAndResultContiner': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  '& .BLSSortBtn': {
    padding: theme.spacing(1),
    fontSize: theme.spacing(2.25),
    '& .SSSSortIcon': {
      fontSize: theme.spacing(3),
    },
  },

  '& .HSSearchInput': {
    backgroundColor: theme.palette.secondary.main,
    backdropFilter: `blur(${theme.spacing(1)})`,
    borderRadius: theme.spacing(1),
    width: theme.typography.pxToRem(500),
    [theme.breakpoints.down('lg')]: {
      width: theme.typography.pxToRem(320),
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },

    '& .MuiInputBase-input ': {
      color: theme.palette.common.white,
      padding: theme.spacing(2, 0, 1.75),
      lineHeight: theme.typography.pxToRem(11),
      height: 'auto',
    },

    '& .MuiOutlinedInput-root': {
      fontSize: theme.typography.pxToRem(16),
      padding: theme.spacing(0, 3),
      '& fieldset': {
        borderColor: theme.palette.divider[7],
      },
      '&:hover fieldset': {
        backgroundColor: `${alpha(theme.palette.secondary.main, 0.25)}`,
        borderColor: `${theme.palette.divider[7]} !important`,
      },
      '&.Mui-focused fieldset': {
        borderColor: `${theme.palette.common.white} !important`,
        color: theme.palette.common.white,
      },
    },
    '& .SSSInputIcon': {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(18),
    },
    '& .SSSCloseIcon': {
      cursor: 'pointer',
    },
  },
  '& .BLSResults': {
    fontSize: theme.spacing(2),
  },
}));

export default StyledBox;
